import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/coach/viewProfile.module.scss";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { coachRoutes } from "../../routers/CoachRouters";
import { getCoachProfile } from "../../services/coachService";
import { dispatch, toggle } from "../../redux";

const ViewProfile = () => {
  const { isLoading, profile } = useSelector((state) => state.coach);
  const navigate = useNavigate();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  useEffect(() => {
    getCoachProfile();
  }, []);
  const handleEdit = () => {
    navigate(coachRoutes.editProfile);
  };
  const handleCancel = () => {
    navigate(coachRoutes.dashboard);
  };
  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={coachRoutes.dashboard}>HOME / </Link>
          PROFILE / <span>EDIT PROFILE</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>PROFILE</h3>
            </div>
          </div>
          <div className={Styles.borderbottomline}></div>

          <div className={Styles.renderedcontentmaindiv}>
            {isLoading ? (
              <div className={Styles.loading_container}>
                <p>Loading...</p>
              </div>
            ) : profile ? (
              <div className={Styles.contentdata}>
                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>ID</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.code || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Name</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.name || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Gym</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.gym.name || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Email ID</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.email || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Password</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.password || "*********"}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Phone</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.phone || ""}</span>
                  </div>
                </div>
                <div className={Styles.button_group}>
                  <button className={Styles.save_button} onClick={handleEdit}>
                    Edit
                  </button>

                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancel}
                  >
                    Back
                  </button>
                </div>
              </div>
            ) : (
              <div className={Styles.no_data_container}>
                <p>No profile available.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewProfile;
